export const groupedExtrasPerPax = ({ uncancelledExtras = [], passengerId }) => {
  const uncancelledExtrasPerPax = uncancelledExtras.filter((extra) => extra.passengerId === passengerId);
  const uncancelledExtrasPerPaxWithQuantity = uncancelledExtrasPerPax.map(({ code, name, price, currency }) => ({
    code,
    name,
    price,
    currency,
    quantity: uncancelledExtrasPerPax.filter((extra) => extra.code === code).length || 1
  }));

  return uncancelledExtrasPerPaxWithQuantity.filter(
    ({ code, passengerId }, index) =>
      uncancelledExtrasPerPaxWithQuantity.findIndex((extra) => extra.code === code && extra.passengerId === passengerId) === index
  );
};

export const formatExtras = ({ extras = [] }) => {
  const uncancelledExtras = extras.filter(({ isCancelled, price }) => !isCancelled && price > 0);
  const formattedExtras = uncancelledExtras.reduce(
    (acc, { passengerId, passenger }) => [
      ...acc,
      {
        firstName: passenger.firstName,
        lastName: passenger.lastName,
        passengerId,
        extras: groupedExtrasPerPax({ uncancelledExtras, passengerId })
      }
    ],
    []
  );

  return formattedExtras.filter(
    ({ passengerId }, index) => formattedExtras.findIndex((extra) => extra.passengerId === passengerId) === index
  );
};
